import { Component, Input, OnInit } from '@angular/core';
import { IdentityService } from '../../../identity/services/identity.service';
import { IUser } from '../../../shared/models/identity.models'; // Assuming you have shared models
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../../services/user.service'; // Import UserService

@Component({
  selector: 'app-user-info-nav',
  templateUrl: './user-info-nav.component.html',
  styleUrls: ['./user-info-nav.component.css']
})
export class UserInfoNavComponent implements OnInit {
  @Input() section?: string;

  adminMode: boolean = false;
  impersonationMode: boolean = false;

  user: IUser = {
    firstName: '',
    lastName: '',
    role: '',
    pictureUrl: '',
    lastLogin: new Date(),
    systemLoginType: 0,
  };

  userFullName: string = '';
  userRoles: string = '';
  pictureUrl: string = '';
  showSparkline: boolean = false;
  lastLogin?: Date;

  constructor(
    private identityService: IdentityService,
    private toastr: ToastrService,
    private userService: UserService // Inject UserService
  ) { }

  ngOnInit(): void {
    this.identityService.getUserLocal().subscribe(
      (response: IUser) => {
        this.user = response;
        this.userFullName = `${this.user.firstName} ${this.user.lastName}`;
        this.userRoles = this.user.role || '';
        //this.pictureUrl = this.user.pictureUrl || 'assets/profile.jpg';
        this.pictureUrl = this.user.pictureUrl || '';
        this.showSparkline = this.user.systemLoginType != undefined && this.user.systemLoginType > 0;
        this.lastLogin = this.user.lastLogin;

        // Store the user information in the UserService
        this.userService.setUser(this.user);
      },
      (error) => {
        this.toastr.error('Failed to load user information');
      }
    );
  }

  logout(): void {
    this.identityService.logout();
  }

  endImpersonation(): void {
    if (
      window.confirm(
        `End Impersonation of current user and get back to your real user account?`
      )
    ) {
      this.identityService.endImpersonation().subscribe({
        next: () => {
          localStorage.clear();
          window.location.href = '/';
        },
        error: (err) =>
          this.toastr.error(`Error ${err.status} ${err.message}`),
      });
    }
  }
}
